module.exports = __webpack_public_path__ + "img/winerackdog47.b5fda141.jpg";